import { clearStoredAuthReturnTo } from './authReturnTo';

const Logoff = (jgkTokens, unlockGalaxyJGKAmount) => {
  clearStoredAuthReturnTo(localStorage);
  localStorage.removeItem('player');
  window.location.href = '/login';
};

export default Logoff;
